/*
 * @Author: chen cs
 * @Date: 2020-02-14 17:22:34
 * @LastEditors: chen cs
 * @LastEditTime: 2020-02-14 17:24:17
 * @Description: file content
 */
/**
 * @Description: 路由配置
 * @Date: 2019-9-25
 * @Modify:
 * @Author: zhangxiaofeng
 */
import Layout from '@/components/layout/Index.vue'

export default [
  {
    path: '/share',
    component: Layout,
    children: [
      {
        path: ':name',
        component: () => import('@/views/share/Index'),
        meta: { title: '分享', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }
    ]
  }
]
